export default {
  default: () => import("/runner/_work/merpay-coupon-web-jp/merpay-coupon-web-jp/modules/app/src/layouts/default.vue").then(m => m.default || m)
}